import { GrillOutlineIcon } from './GrillOutlineIcon';

/**
 * author: Google
 * id 36BD13EA-FFEC-48CF-855C-C30831680961
 * name grill-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/grill-outline.svg
 * tags
 * - Food / Drink 
 */
export const BarbecueOutlineIcon = GrillOutlineIcon;
export default BarbecueOutlineIcon